import listAPI from "../api/api";
import CreateDataContext from "./CreateDataContext";

const AuthReducer = (state, action) => {
  switch (action.type) {
    case "get_login_user":
      return { ...state, LoginList: action.payload };
    case "get_login_user_status":
      return { ...state, LoginStatus: action.payload };
    case "get_login_user_error":
      return { ...state, LoginError: action.payload };
    case "clear_get_login_user_status":
      return { ...state, LoginStatus: "", LoginError: "" };
    case "add_register_user":
      return { ...state, RegisterList: action.payload };
    case "add_register_user_status":
      return { ...state, RegisterStatus: action.payload };
    case "clear_add_register_user_status":
      return { ...state, RegisterStatus: "" };
    default:
      return state;
  }
};

const registerUser =
  (dispatch) =>
  async ({
    user_name,
    user_email,
    user_phone,
    password,
    user_role,
    user_permission,
  }) => {
    const data = {
      user_name: user_name,
      user_email: user_email,
      user_phone: user_phone,
      password: password,
      user_role: user_role,
      user_permission: user_permission,
    };
    try {
      const response = await listAPI.post("/api/auth/create", data);
      dispatch({ type: "add_register_user", payload: response });
      dispatch({ type: "add_register_user_status", payload: response.status });
    } catch (err) {
      dispatch({ type: "add_register_user_status", payload: 400 });
    }
  };

const clearRegisterUser = (dispatch) => () => {
  dispatch({ type: "clear_add_register_user_status" });
};

const loginUser =
  (dispatch) =>
  async ({ email, password }) => {
    const data = {
      email: email,
      password: password,
    };
    try {
      const response = await listAPI.post("/admin/loginAdmin", data);

      if (response.data && response.data.status === true) {
        if (response.data.token) {
          sessionStorage.setItem("admin_token", response.data.token);
        }

        if (response.data.data) {
          const adminId = response.data.data.id || response.data.data.admin_id;
          if (adminId) {
            sessionStorage.setItem("admin_id", adminId);
          }
        }

        dispatch({ type: "get_login_user", payload: response.data.data });
        dispatch({ type: "get_login_user_error", payload: "" });
        dispatch({ type: "get_login_user_status", payload: 200 });
      } else {
        const errorMsg = response.data.message || "Invalid email or password.";
        dispatch({ type: "get_login_user_error", payload: errorMsg });
        dispatch({ type: "get_login_user_status", payload: 400 });
      }
    } catch (err) {
      const errorMsg =
        err.response?.data?.message ||
        err.message ||
        "Network error: Unable to reach the server.";

      const errorStatus = err.response?.status || 500;

      dispatch({ type: "get_login_user_error", payload: errorMsg });
      dispatch({ type: "get_login_user_status", payload: errorStatus });
    }
  };

const clearLoginUser = (dispatch) => () => {
  dispatch({ type: "clear_get_login_user_status" });
};

export const { Provider, Context } = CreateDataContext(
  AuthReducer,
  { loginUser, clearLoginUser, registerUser, clearRegisterUser },
  {
    LoginList: [],
    LoginStatus: "",
    LoginError: "",
    RegisterList: [],
    RegisterStatus: "",
  },
);
